export const QUESTION_MAPPING = {
  firstName: {
    section: 0,
    question: 0,
    answerType: "answerValue",
    behaviour: "value-only",
    box: 0,
  },
  lastName: { section: 0, question: 1, answerType: "answerValue", behaviour: "value-only", box: 0 },
  workPlace: {
    section: 0,
    question: 2,
    answerType: "answerValue",
    box: 0,
  },
  for: { section: 0, question: 3, answerType: "label", box: 0 },
  phone: {
    section: 0,
    question: 4,
    answerType: "answerValue",
    box: 0,
  },
  otherPhone: {
    section: 0,
    question: 5,
    answerType: "answerValue",
    box: 0,
  },
  mail: {
    section: 0,
    question: 6,
    answerType: "answerValue",
    box: 0,
  },
  studentFirstName: {
    section: 1,
    question: 0,
    answerType: "answerValue",
    behaviour: "value-only",
    box: 1,
  },
  studentLastName: {
    section: 1,
    question: 1,
    answerType: "answerValue",
    behaviour: "value-only",
    box: 1,
  },
  studentSex: { section: 1, question: 2, answerType: "label", box: 1 },
  studentBirthdate: { section: 1, question: 3, answerType: "date", box: 1 },
  studentCF: { section: 1, question: 4, answerType: "answerValue", box: 1 },
  school: { section: 1, question: 5, answerType: "label", box: 1 },
  prizedStudent: { section: 1, question: 6, answerType: "label", box: 1 },
  prizesReceived: { section: 1, question: 7, answerType: "answerValue", box: 1 },
  iban: { section: 1, question: 8, answerType: "answerValue", box: 1 },
  holder: { section: 1, question: 9, answerType: "answerValue", box: 1 },
  familyDocument: { section: 1, question: 10, answerType: "fileId", box: 1 },
  sport: { section: 1, question: 11, answerType: "answerValue", box: 1 },
  photo: { section: 1, question: 13, answerType: "fileId", box: 1 },
};

export const SCHOOL_QUESTION_MAPPING = {
  ss1g: {
    ss1g_instituteName: {
      section: 2,
      question: 0,
      answerType: "answerValue",
      box: 2,
    },
    ss1g_finalGrade: { section: 2, question: 1, answerType: "label", box: 2 },
    ss1g_examCertificate: {
      section: 2,
      question: 2,
      answerType: "fileId",
      box: 2,
    },
    ss1g_gradeCertificate: {
      section: 2,
      question: 3,
      answerType: "fileId",
      box: 2,
    },
    ss1g_meanOver8_5: {
      section: 2,
      question: 4,
      answerType: "label",
      box: 2,
    },
    ss1g_firstYearMean: {
      section: 3,
      question: 0,
      answerType: "label",
      box: 2,
    },
    ss1g_firstYearMean_actualGrade: { section: 3, question: 1, answerType: "answerValue", box: 2 },
    ss1g_firstYearReport: {
      section: 3,
      question: 2,
      answerType: "fileId",
      box: 2,
    },
    ss1g_secondYearMean: {
      section: 3,
      question: 3,
      answerType: "label",
      box: 2,
    },
    ss1g_secondYearMean_actualGrade: { section: 3, question: 4, answerType: "answerValue", box: 2 },
    ss1g_secondYearReport: {
      section: 3,
      question: 5,
      answerType: "fileId",
      box: 2,
    },
  },
  ss2g: {
    ss2g_instituteName: {
      section: 4,
      question: 0,
      answerType: "answerValue",
      box: 2,
    },
    ss2g_instituteType: {
      section: 4,
      question: 1,
      answerType: "label",
      box: 2,
    },
    ss2g_schoolType: {
      section: 4,
      question: 2,
      answerType: "answerValue",
      box: 2,
    },
    ss2g_class: {
      section: 4,
      question: 3,
      answerType: "label",
      box: 2,
    },
    ss2g_mean: {
      section: 5,
      question: 0,
      answerType: "label",
      box: 2,
    },
    ss2g_mean_actualGrade: {
      section: 5,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    ss2g_report: {
      section: 5,
      question: 2,
      answerType: "fileId",
      box: 2,
    },
    ss2g_meanCertificate: {
      section: 5,
      question: 3,
      answerType: "fileId",
      box: 2,
    },
    ss2g_foreignSchoolCertificate: {
      section: 5,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
    ss2g_finalGrade: {
      section: 6,
      question: 0,
      answerType: "label",
      box: 2,
    },
    ss2g_finalGrade_actualGrade: {
      section: 6,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    ss2g_finalExamCertificate: {
      section: 6,
      question: 2,
      answerType: "fileId",
      box: 2,
    },
    ss2g_lastYearMeanCertificate: {
      section: 6,
      question: 3,
      answerType: "fileId",
      box: 2,
    },
    ss2g_lastYearForeignSchoolCertificate: {
      section: 6,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
  },
  uni: {
    uni_instituteName: {
      section: 7,
      question: 0,
      answerType: "answerValue",
      box: 2,
    },
    uni_instituteType: {
      section: 7,
      question: 1,
      answerType: "label",
      box: 2,
    },
    uni_courseName: {
      section: 7,
      question: 2,
      answerType: "answerValue",
      box: 2,
    },
    uni_enrollmentYear: {
      section: 7,
      question: 3,
      answerType: "answerValue",
      box: 2,
    },
    uni_enrollmentCertificate: {
      section: 7,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
    uni_attendanceCertificate: {
      section: 7,
      question: 5,
      answerType: "fileId",
      box: 2,
    },
    uni_studyPlan: {
      section: 7,
      question: 6,
      answerType: "fileId",
      box: 2,
    },
    uni_meanCertificate: {
      section: 7,
      question: 7,
      answerType: "fileId",
      box: 2,
    },
    uni_foreignSchoolCertificate: {
      section: 7,
      question: 8,
      answerType: "fileId",
      box: 2,
    },
    uni_courseType: {
      section: 7,
      question: 9,
      answerType: "label",
      box: 2,
    },
    uni_triennaleCurrentYear: {
      section: 8,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_magistraleCurrentYear: {
      section: 9,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_5yCurrentYear: {
      section: 10,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_gradesMean: {
      section: 11,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_gradesMean_actualGrade: {
      section: 11,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    uni_taxAmount: {
      section: 11,
      question: 2,
      answerType: "answerValue",
      box: 2,
    },
    uni_taxDetailFile: {
      section: 11,
      question: 3,
      answerType: "fileId",
      box: 2,
    },
    uni_taxPayment: {
      section: 11,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
    uni_finalGrade: {
      section: 12,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_finalGrade_actualGrade: {
      section: 12,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    uni_magistraleFinalGrade: {
      section: 13,
      question: 0,
      answerType: "label",
      box: 2,
    },
    uni_magistraleActualGrade: {
      section: 13,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    uni_laude: {
      section: 12,
      question: 2,
      answerType: "label",
      box: 2,
    },
    uni_magistraleLaude: {
      section: 13,
      question: 1,
      answerType: "label",
      box: 2,
    },
    //CHECK THIS
    uni_graduationDate: {
      section: 12,
      question: 3,
      answerType: "date",
      box: 2,
    },
    uni_magistraleGraduationDate: {
      section: 13,
      question: 2,
      answerType: "date",
      box: 2,
    },
    uni_courseDuration: {
      section: 12,
      question: 4,
      answerType: "answerValue",
      box: 2,
    },
    uni_magistraleCourseDuration: {
      section: 13,
      question: 3,
      answerType: "answerValue",
      box: 2,
    },
    uni_graduationCertificate: {
      section: 12,
      question: 5,
      answerType: "fileId",
      box: 2,
    },
    uni_magistraleGraduationCertificate: {
      section: 13,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
  },
  m2l: {
    m2l_instituteName: {
      section: 14,
      question: 0,
      answerType: "answerValue",
      box: 2,
    },
    m2l_courseName: {
      section: 14,
      question: 1,
      answerType: "answerValue",
      box: 2,
    },
    m2l_grade: {
      section: 14,
      question: 2,
      answerType: "answerValue",
      box: 2,
    },
    m2l_date: {
      section: 14,
      question: 3,
      answerType: "date",
      box: 2,
    },
    m2l_attendanceCertificate: {
      section: 14,
      question: 4,
      answerType: "fileId",
      box: 2,
    },
    m2l_graduationCertificate: {
      section: 14,
      question: 5,
      answerType: "fileId",
      box: 2,
    },
    m2l_paymentReceipt: {
      section: 14,
      question: 6,
      answerType: "fileId",
      box: 2,
    },
  },
  dtt: {
    dtt_description: {
      section: 15,
      question: 0,
      answerType: "answerValue",
      box: 2,
    },
    dtt_graduationCertificate: {
      section: 15,
      question: 1,
      answerType: "fileId",
      box: 2,
    },
    dtt_attendanceCertificate: {
      section: 15,
      question: 2,
      answerType: "fileId",
      box: 2,
    },
    dtt_annualCertificate: {
      section: 15,
      question: 3,
      answerType: "fileId",
      box: 2,
    },
  },
};
